import { render, staticRenderFns } from "./QuestionStatistics.vue?vue&type=template&id=ee2b2c20&"
import script from "./QuestionStatistics.vue?vue&type=script&lang=js&"
export * from "./QuestionStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports